export const HOST = "HOST";
export const REST_ID = "REST_ID";
